
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/premium-support",
      function () {
        return require("private-next-pages/learn/premium-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/premium-support"])
      });
    }
  